/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import Accordion from 'shared/Accordion';
import CircleButton from 'shared/buttons/CircleButton';
import LiveSourceSection from './LiveSourceSection';

type ImportOptionsProps = {
  togglePasting: () => void;
  setShowLiveSourceModal: React.Dispatch<React.SetStateAction<boolean>>;
  isChart: boolean;
  isMap: boolean;
  isPackedBubble: boolean;
  onClickUpload: () => void;
  aggregatedOptions: any;
  isLiveDataSource: boolean;
  dataConfig?: any;
};

const ImportOptions = ({
  isPackedBubble,
  togglePasting,
  isChart,
  isMap,
  setShowLiveSourceModal,
  onClickUpload,
  aggregatedOptions,
  isLiveDataSource,
  dataConfig
}: ImportOptionsProps) => {
  return (
    <Accordion headerText="Add your own data" useInternalSelect={true}>
      <div>Use the options below if you want to import your own data</div>
      <div className="grid gap-4 pt-4 grid-cols-3">
        <div className="button-container">
          <CircleButton icon={'clipboard'} text={'Paste'} onClick={() => togglePasting()} />
        </div>

        <div className="button-container">
          <CircleButton icon={'upload'} text={'Upload'} onClick={onClickUpload} />
        </div>

        <div className="button-container">
          {((isChart && !isMap && !isPackedBubble) || !isChart) && (
            <CircleButton icon={'link'} text={'Link data'} onClick={() => setShowLiveSourceModal(true)} />
          )}
        </div>
      </div>

      <hr className="border-t border-t-ev-grey-3 my-4" />
      {isLiveDataSource && (
        <LiveSourceSection
          aggregatedOptions={aggregatedOptions}
          setShowLiveSourceModal={setShowLiveSourceModal}
          dataConfig={dataConfig}
        />
      )}
      <div className="mb-4">
        For help adding data, check out our help articles under{' '}
        <a
          className="font-bold"
          href="https://help.everviz.com/category/318-working-with-data"
          target={'_blank'}
          rel="noreferrer"
        >
          Working with data
        </a>
      </div>
    </Accordion>
  );
};

export default ImportOptions;
